/* eslint-disable react/display-name */
// * You should NOT edit this file directly. Read CONTRIBUTING.md for more information on creating icons
import { __assign } from "tslib";
import React from 'react';
import { forwardRef } from '../../helpers/forwardRef';
import { Icon } from '../../internal/Icon';
import { ArrowCLeftIcon16Light } from './ArrowCLeftIcon16Light';
import { ArrowCLeftIcon16Regular } from './ArrowCLeftIcon16Regular';
import { ArrowCLeftIcon16Solid } from './ArrowCLeftIcon16Solid';
import { ArrowCLeftIcon20Light } from './ArrowCLeftIcon20Light';
import { ArrowCLeftIcon20Regular } from './ArrowCLeftIcon20Regular';
import { ArrowCLeftIcon20Solid } from './ArrowCLeftIcon20Solid';
import { ArrowCLeftIcon24Regular } from './ArrowCLeftIcon24Regular';
import { ArrowCLeftIcon24Solid } from './ArrowCLeftIcon24Solid';
import { ArrowCLeftIcon32Regular } from './ArrowCLeftIcon32Regular';
import { ArrowCLeftIcon64Regular } from './ArrowCLeftIcon64Regular';
var sizes = {
    16: {
        light: ArrowCLeftIcon16Light,
        regular: ArrowCLeftIcon16Regular,
        solid: ArrowCLeftIcon16Solid,
    },
    20: {
        light: ArrowCLeftIcon20Light,
        regular: ArrowCLeftIcon20Regular,
        solid: ArrowCLeftIcon20Solid,
    },
    24: {
        regular: ArrowCLeftIcon24Regular,
        solid: ArrowCLeftIcon24Solid,
    },
    32: {
        regular: ArrowCLeftIcon32Regular,
    },
    64: {
        regular: ArrowCLeftIcon64Regular,
    },
};
export var ArrowCLeftIcon = forwardRef('ArrowCLeftIcon', function (props, ref) {
    return React.createElement(Icon, __assign({ ref: ref }, props, { sizes: sizes }));
});
